import { render } from "./DeansReportsDialog.vue?vue&type=template&id=3b0ed2a6"
import script from "./DeansReportsDialog.vue?vue&type=script&lang=js"
export * from "./DeansReportsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__